import { format } from 'date-fns';

export const notificationConfig = {
  quietHours: {
    start: 22,  // 10pm
    end: 6      // 6am
  }
};

export const requestNotificationPermission = async () => {
  if (!('Notification' in window)) {
    console.log('Notifications not supported');
    return false;
  }
  
  const permission = await Notification.requestPermission();
  return permission === 'granted';
};

export const shouldSendReminder = (user, now = new Date()) => {
  const hour = now.getHours();
  
  // Check quiet hours
  if (hour >= notificationConfig.quietHours.start || 
      hour < notificationConfig.quietHours.end) {
    return false;
  }
  
  // Check if already trained today
  const today = format(now, 'yyyy-MM-dd');
  if (user.stats.lastTrainingDate === today) {
    return false;
  }
  
  return true;
};

export const sendTrainingReminder = (user) => {
  if (!shouldSendReminder(user)) return;
  
  const hour = new Date().getHours();
  let message;
  
  if (hour < 12) {
    message = `Good morning! Start your day with ${user.settings.dailyGoalMinutes} minutes of training 🌅`;
  } else if (hour < 17) {
    message = `Time for your daily practice! Keep that ${user.stats.currentStreak} day streak alive 🔥`;
  } else {
    message = `Evening training time! Let's keep that ${user.stats.currentStreak} day streak going 💪`;
  }
  
  if ('Notification' in window && Notification.permission === 'granted') {
    const notification = new Notification('Martial Arts Training 🥋', {
      body: message,
      icon: '/icon-192.png',
      badge: '/badge-72.png',
      tag: 'daily-reminder',
      requireInteraction: false
    });
    
    notification.onclick = () => {
      window.focus();
      window.location.href = '/training';
      notification.close();
    };
  }
};

// Schedule reminder check
export const scheduleReminders = (user) => {
  if (!user.settings.reminderEnabled) return;
  
  const now = new Date();
  const [hours, minutes] = user.settings.reminderTime.split(':');
  const reminderTime = new Date();
  reminderTime.setHours(parseInt(hours), parseInt(minutes), 0);
  
  if (reminderTime < now) {
    reminderTime.setDate(reminderTime.getDate() + 1);
  }
  
  const delay = reminderTime - now;
  
  setTimeout(() => {
    sendTrainingReminder(user);
    // Reschedule for next day
    scheduleReminders(user);
  }, delay);
};

